import React from 'react';
import Select from 'react-select';
import ColorPicker from './ColorPicker.js';


class FontPicker extends React.Component {
    constructor(props) {
        super(props);  

        this.fonts = [
            { value: 'inherit',clearableValue:false, label: this.renderLabel('inherit','Inherit') },
            { value: 'helvetica neue,helvetica,arial,verdana,sans-serif',clearableValue:false, label: this.renderLabel('helvetica neue,helvetica,arial,verdana,sans-serif','Helvetica') },
            { value: 'arial,helvetica neue,helvetica,sans-serif',clearableValue:false, label: this.renderLabel('arial,helvetica neue,helvetica,sans-serif','Arial') },
            { value: 'lucida sans unicode,lucida grande,sans-serif',clearableValue:false, label: this.renderLabel('lucida sans unicode,lucida grande,sans-serif','Lucida') },
            { value: 'tahoma,verdana,segoe,sans-serif',clearableValue:false, label: this.renderLabel('tahoma,verdana,segoe,sans-serif','Tahoma') },
            { value: 'verdana,geneva,sans-serif',clearableValue:false, label: this.renderLabel('helvetica neue,helvetica,arial,verdana,sans-serif','Verdana') },

            { value: "'Open Sans', sans-serif",clearableValue:false, label: this.renderLabel("'Open Sans', sans-serif","Open Sans") },
            { value: "'Source Sans Pro', sans-serif",clearableValue:false, label: this.renderLabel("'Source Sans Pro', sans-serif","Source Sans Pro") },
            { value: "'Roboto', sans-serif",clearableValue:false, label: this.renderLabel("'Roboto', sans-serif","Roboto") },
            { value: "'Lato', sans-serif",clearableValue:false, label: this.renderLabel("'Lato', sans-serif","Lato") },
            { value: "'Exo', sans-serif",clearableValue:false, label: this.renderLabel("'Exo', sans-serif","Exo") },

        ];

        this.sizes = [
            { value: 'inherit',clearableValue:false, label:'Inherit' }
        ];

        for(let i = 10; i<=72;i++) {
            this.sizes.push({ value: i+'px',clearableValue:false, label:i+'px' });
        }

        this.onChangeFont = this.onChangeFont.bind(this);
        this.onChangeSize = this.onChangeSize.bind(this);
        this.onChangeColor = this.onChangeColor.bind(this);


    }

    renderLabel(value,label) {
        return <span style={{fontFamily:value}}>{label}</span>
    }

    onChangeFont(v) {
        this.props.handleChange(this.props.fontId,v.value);
    }

    onChangeSize(v) {
        this.props.handleChange(this.props.sizeId,v.value);
    }

    onChangeColor(id,v) {
        this.props.handleChange(id,v);
    }

    render() {     
        return (
            <div className="col-sm-12 p-0">
                <div className="col-sm-4 p-0">
                    <Select
                        allowCreate={false}
                        searchable={false}
                        clearable={false}
                        name="form-field-name"
                        value={this.props.font}
                        options={this.fonts}
                        onChange={this.onChangeFont}
                    />
                </div>
                <div className="col-sm-4">
                    <Select
                        allowCreate={false}
                        searchable={false}
                        clearable={false}
                        name="form-field-name"
                        value={this.props.size}
                        options={this.sizes}
                        onChange={this.onChangeSize}
                    />
                </div>
                <div className="col-sm-4">
                    <ColorPicker id={this.props.colorId} color={this.props.color} handleColorChange={this.onChangeColor} />
                </div>
                
            </div>
        );
    }

  
}

export default FontPicker;




// WEBPACK FOOTER //
// ./components/builder/FontPicker.js